module.exports = __webpack_public_path__ + "static/luxury-beds-a8ac352dce01692297b8b5d12598d55b.png";